import swap from "./swap.svg";

export default function SwapIcon() {
  return (
    <img src={swap} />
  );
}